import React from 'react';
import { TooltipSH, TooltipContent, TooltipProvider, TooltipTrigger } from '@shared/components/ui/shadcn/tooltip';
import { cn } from '@shared/utils/utils';

interface Props {
  content: React.ReactNode;
  trigger: React.ReactNode;
  side?: 'top' | 'right' | 'bottom' | 'left';
  sideOffset?: number;
  align?: 'start' | 'center' | 'end';
  sticky?: 'partial' | 'always';
  updatePositionStrategy?: 'optimized' | 'always';
  'data-testid'?: string;
  className?: string; // ✅ clases adicionales desde el usuario
  /** Si true, el tooltip no se abre (p. ej. cuando no aplica el mensaje) */
  disabled?: boolean;
  /** Control explícito de apertura; si no se pasa, se usa hover/focus por defecto */
  open?: boolean;
}

const Tooltip: React.FC<Props> = ({
  content,
  trigger,
  side = 'top',
  sideOffset = 4,
  align = 'center',
  sticky = 'partial',
  updatePositionStrategy = 'optimized',
  'data-testid': testId = 'tooltip',
  className,
  disabled = false,
  open,
}) => {
  const rootProps = disabled ? { open: false as const } : open !== undefined ? { open } : {};

  return (
    <TooltipProvider delayDuration={100}>
      <TooltipSH {...rootProps}>
        <TooltipTrigger data-testid={`${testId}-trigger`} asChild>
          {trigger}
        </TooltipTrigger>
        <TooltipContent
          side={side}
          updatePositionStrategy={updatePositionStrategy}
          align={align}
          sideOffset={sideOffset}
          sticky={sticky}
          data-testid={`${testId}-content`}
          className={cn('z-[200] bg-body-bg border border-card-border text-md', className)}
        >
          {content}
          {/* <TooltipArrow className="fill-border" /> */}
        </TooltipContent>
      </TooltipSH>
    </TooltipProvider>
  );
};

export default Tooltip;
